import { Category } from '@obeta/models/lib/models/Category'
import { ArticleSearchParams } from '@obeta/models/lib/models/Search'
import { CategoryFacetsResult, constructCategoryFacet } from '@obeta/utils/lib/search/facets'
import { useArticlesSearchProvider } from './useArticleSearchProvider'

const typeToCatalogIdMapping: Record<'obetaCategory' | 'dehaCategory', string> = {
  obetaCategory: 'obetaCatalogIds',
  dehaCategory: 'dehaCatalogIds',
}

export const useCategories = (p: {
  searchParams?: ArticleSearchParams
  type: keyof Pick<ArticleSearchParams, 'obetaCategory' | 'dehaCategory'>
  currentCategory: Category | undefined
}): { categories: CategoryFacetsResult; loading: boolean } => {
  const { facets, isFetching } = useArticlesSearchProvider()

  const categoryFacets = constructCategoryFacet(
    p.currentCategory?.level,
    p.type === 'obetaCategory' ? 'obetaCatalogIds' : 'dehaCatalogIds'
  )

  const filteredFacets = facets.filter((facet) =>
    facet?.name?.startsWith(typeToCatalogIdMapping[p.type])
  )
  return { categories: categoryFacets.createCatalog(filteredFacets), loading: isFetching }
}
